module.exports = __webpack_public_path__ + "youtube-dark--276e992d.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/icons/youtube-dark.png
// module id = 23
// module chunks = 0